/** Mirrors the backend's LEFT_CAMPAIGN_REASON (src/lib/cpmCampaignLeave/). */
export const LEFT_CAMPAIGN_REASON = 'left_campaign';

export const APPEAL_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

function cycleMs(value: unknown): number {
  if (value instanceof Date) return value.getTime();
  const parsed = Date.parse(String(value ?? ''));
  return Number.isFinite(parsed) ? parsed : NaN;
}

export function canCreateCpmSubmissionAppeal({
  campaign,
  submission,
  now,
  existingForCycle,
}: {
  campaign: { status?: string | null } | null | undefined;
  submission: {
    admin_approval?: string | null;
    disqualified?: boolean | null;
    approval_reason?: string | null;
    content_review_group?: unknown;
    content_review_group_id?: string | null;
    disapproved_at?: string | Date | null;
  } | null | undefined;
  now: Date;
  existingForCycle: unknown;
}): { ok: true; code: null } | { ok: false; code: string } {
  if (!campaign || campaign.status !== 'active') {
    return { ok: false, code: 'campaign_not_active' };
  }
  if (!submission || submission.admin_approval !== 'disapproved') {
    return { ok: false, code: 'not_disapproved' };
  }
  if (submission.disqualified) {
    return { ok: false, code: 'disqualified_submission' };
  }
  // The clipper chose to leave; there is no reviewer decision to contest.
  if (submission.approval_reason === LEFT_CAMPAIGN_REASON) {
    return { ok: false, code: 'left_campaign' };
  }
  if (submission.content_review_group || submission.content_review_group_id) {
    return { ok: false, code: 'grouped_submission' };
  }
  const stamped = cycleMs(submission.disapproved_at);
  const nowMs = now && typeof now.getTime === 'function' ? now.getTime() : NaN;
  if (
    !Number.isFinite(stamped)
    || !Number.isFinite(nowMs)
    || (nowMs - stamped) > APPEAL_WINDOW_MS
  ) {
    return { ok: false, code: 'appeal_window_closed' };
  }
  if (existingForCycle) {
    return { ok: false, code: 'appeal_already_exists' };
  }
  return { ok: true, code: null };
}
